import { render, staticRenderFns } from "./Introduction.vue?vue&type=template&id=190c2b61&scoped=true"
import script from "./Introduction.vue?vue&type=script&lang=js"
export * from "./Introduction.vue?vue&type=script&lang=js"
import style0 from "./Introduction.vue?vue&type=style&index=0&id=190c2b61&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190c2b61",
  null
  
)

export default component.exports